import { takeEvery } from "redux-saga/effects";
import { setDimensions } from "../hotspotEditor/hotspotEditorReducers";
import { loadImagesInLayer } from "./loadImages";

export function* setDimensionsWatcher() {
  yield takeEvery(setDimensions().type, loadImagesInLayer);
}
